// Reducer
import { ACTION_TYPES } from './customer.actions';
import { CustomerState, initialState } from './customer.state';

export default (state: CustomerState = initialState, action): CustomerState => {
  switch (action.type) {
    case ACTION_TYPES.UPDATE_CUSTOMER: {
      const customer = action.payload;
      customer.phoneNumber = customer.phoneNumber || '';

      return {
        ...customer
      };
    }
    case ACTION_TYPES.RESET_ADDRESS:
      return {
        ...state,
        streetNumber: initialState.streetNumber,
        address: initialState.address,
        zipCode: initialState.zipCode,
        city: initialState.city,
        iso2country: initialState.iso2country,
        selectAddressAutocompletete: false,
        changeAddressManually: true,
        searchAddressFeatures: undefined
      };
    default:
      return state;
  }
};
